// extracted by mini-css-extract-plugin
export default {"table":"catalogTable_table__GlWH7","actionsColumn":"catalogTable_actionsColumn__-ws2m"};